<script>
export default {
  name: 'EllipsisWithTooltip',
  props: {
    text: {
      type: String,
    },
    limit: {
      type: Number,
      required: true,
    },
    mainClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<template lang="pug">
.text-black-15(v-if="!text?.length") empty
div(
  v-else-if="text.length > limit"
  :class="mainClass"
  style="max-width: 300px; word-wrap: break-word"
  v-tooltip="text"
) {{ text.substring(0, limit) }}...
div(v-else :class="mainClass" style="max-width: 300px; word-wrap: break-word") {{ text }}
</template>
